import { type GetHookResponse } from '../hooks'
import { importErrorsKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type ImportErrorsInput,
  type ImportErrorsSuccess,
  type ImportId,
  type ImportObjectMetadata,
} from '@terros/common'

export function useImportErrors(importId: ImportId): GetHookResponse<ImportObjectMetadata[]> {
  return useTantalimQuery<ImportErrorsInput, ImportErrorsSuccess, ImportObjectMetadata[]>({
    url: '/import/errors',
    queryKey: importErrorsKey(importId),
    input: { importId },
    convertResponse: (data) => {
      return data.records
    },
  })
}
